import { useState, useEffect, type ReactNode } from "react";
import { LayoutStyleContext, type LayoutStyle } from "./layout-style-context";

const STORAGE_KEY = "silpi-admin:layout-style";

function readPersistedStyle(): LayoutStyle {
  try {
    return localStorage.getItem(STORAGE_KEY) === "legacy" ? "legacy" : "sidebar";
  } catch {
    return "sidebar";
  }
}

// Preferência por navegador, não por usuário — se um dia isso precisar ser
// visível para o time de suporte, mover para uma coluna em usuario-logado é o
// próximo passo natural. Por ora, localStorage é suficiente: é uma muleta visual
// de transição, não configuração de conta.
export function LayoutStyleProvider({ children }: { children: ReactNode }) {
  const [style, setStyle] = useState<LayoutStyle>(readPersistedStyle);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, style);
    } catch {
      // localStorage indisponível — degrada para não persistir.
    }
  }, [style]);

  return <LayoutStyleContext.Provider value={{ style, setStyle }}>{children}</LayoutStyleContext.Provider>;
}
